import { useStore } from 'vuex'
import { computed, ref, onMounted} from 'vue'
import StafetHeader from '../StafetHeader/StafetHeader.vue'
import StafetOpretHoldStepOne from '../StafetOpretHoldStepOne/StafetOpretHoldStepOne.vue'
import StafetOpretHoldStepTwo from '../StafetOpretHoldStepTwo/StafetOpretHoldStepTwo.vue'
import FormStepSubmitting from '../FormStepSubmitting/FormStepSubmitting.vue'
import getCommonComputedFields from 'foundation/js/stafet/getCommonComputedFields'
import mapStafetHeaderSteps from 'foundation/js/stafet/mapStafetHeaderSteps'
import sessionStorageIdentifierEnum from 'foundation/js/sessionStorageWrapper/sessionStorageIdentifierEnum'
import updateItemFromStorage from 'foundation/js/sessionStorageWrapper/updateItemFromStorage'
import { scrollToFirstError } from '../../foundation/js/inputValidators/scrollToFirstError'
import stepsConfig from './config/stepsConfig'
import fieldValidator from 'foundation/js/stafet/fieldValidator'

export default {
    name: 'StafetOpretHoldFlow',
    components: {
        StafetHeader,
        StafetOpretHoldStepOne,
        StafetOpretHoldStepTwo,
        FormStepSubmitting
    },
    props: {
        stafetId: {
            type: String,
            required: true,
            default: null
        },
        holdList: {
            type: Array,
            required: true,
            default: []
        },
        holdData: {
            type: Object,
            required: false,
            default: {}
        },
        userData: {
            type: Object,
            required: false,
            default: {}
        },
        loggedIn: {
            type: Boolean,
            required: true,
            default: false
        }
    },
    setup(props) {
        const store = useStore()
        const displayInputError = ref(false)

        const labels = computed(() => {
            return store.state.labels.collections['SFLCreateHoldLabels']
        })

        const isSubmitting = computed(() => {
            return store.state.stafet.isSubmitting
        })

        const headerSteps = computed(() => {
            return mapStafetHeaderSteps(
                steps.value,
                currentStep.value,
                labels.value
            )
        })

        onMounted(() => {
            store.dispatch('stafet/stafetId', { stafetId: props.stafetId })
            store.dispatch('stafet/steps', {
                steps: stepsConfig
            })
        })

        const { userInputs, steps, currentStep, currentStepName } =
            getCommonComputedFields(store.state.stafet)

        const handleStepCompleted = () => {
            steps.value.find(
                (item) => item.step === currentStep.value
            ).completed = true

            store.dispatch('stafet/steps', {
                steps: steps.value
            })

            const unCompletedSteps = steps.value.filter(
                (item) => !item.completed
            )

            if (unCompletedSteps.length > 0) {
                store.dispatch('stafet/currentStep', {
                    step: unCompletedSteps[0].step
                })
            }
        }

        
        const nextStepCallback = (fields) => {
            fields.forEach((field) => {
                if (field.dependentField) {
                    const dependentField = fields.find(
                        (item) => item.name === field.dependentField
                    )

                    if (dependentField) {
                        field.dependentFieldValue = dependentField.value
                    }
                }
                fieldValidator(field)
            })

            const isStepValid = fields.every((field) => field.isValid)
            if (isStepValid) {
                displayInputError.value = false
                handleStepCompleted()
                store.dispatch('stafet/userInputs', { inputs: fields })

                updateItemFromStorage(
                    sessionStorageIdentifierEnum.STAFET_CREATE_A_TEAM,
                    fields
                )
                scrollTo(0, 0)  
            } else {
                displayInputError.value = true
                scrollToFirstError()
            }
        }

        const previousStepCallback = () => {
            if (currentStep.value > 1) {
                store.dispatch('stafet/currentStep', {
                    step: currentStep.value - 1
                })

                steps.value.find(
                    (item) => item.step === currentStep.value
                ).completed = false

                store.dispatch('stafet/steps', {
                    steps: steps.value
                })
                scrollTo(0, 0)  
            }
        }

        const submitCallback = async () => {
            // it expects a object with ok: true or false
            const response = await store.dispatch('stafet/createTeamSubmit')
            return response
        }

        return {
            displayInputError,
            labels,
            headerSteps,
            currentStepName,
            isSubmitting,
            nextStepCallback,
            previousStepCallback,
            submitCallback
        }
    }
}
